import React from "react";
import {Redirect} from "react-router-dom";

export default () => {
    window.location.href = '/v2/bookings'
    return (
        <Redirect to={'/v2/bookings'} />
    )
}